export default __webpack_public_path__ + "bf407c286b98d8f784a9777f2468c7fe.png";